import { IsIn, IsNotEmpty, IsOptional, IsBoolean } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IPrecisionCoursingScore } from "./precision-coursing-score.interface";

export class PrecisionCoursingScoreDto implements IPrecisionCoursingScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  search_time?: string; //mm:ss:tt. Only if result_type == Constants.score_result_type.qualified

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
